import React from 'react';
import { useLocalization } from '../../../../utils/useLocalization';
import { useNavigate } from 'react-router-dom';
import './styles.scss';

export interface IProps {
    email: string;
}

const PasswordSuccess: React.FC<IProps> = ({ email }) => {
    const { passwordReset, forgotPassword } = useLocalization();
    const navigation = useNavigate();

    function backHandler() {
        navigation('/login');
    }
    return (
        <div className={'forgot_password_container'}>
            <div className={'header u-mt-xlarge'}>
                <h4>{forgotPassword.TITLE}</h4>
                <p className={'description u-mt'}>
                    {`${forgotPassword.SUCCESS_INFO} ${email}${forgotPassword.SUCCESS_INFO2}`}
                </p>
            </div>
            <div className='o-button-container'>
                <button
                    className={'c-btn c-btn--full'}
                    type={'button'}
                    onClick={backHandler}
                >
                    <span className='c-btn__text'>
                        {passwordReset.LABEL_BACK_BUTTON}
                    </span>
                </button>
            </div>
        </div>
    );
};

export default PasswordSuccess;
